import { InjectionToken } from '@angular/core';

/**
 * A modal that decides on its own whether it must be shown after login
 * (onboarding, HubSpot survey, ...). It owns its eligibility rules;
 * `AppPromptQueueService` owns the order they appear in.
 */
export interface AppPrompt {
  /** Starts listening. Calling it more than once must be a no-op. */
  start(): void;
}

/**
 * Multi-provider of every app-wide prompt. Registering a new prompt is a new
 * entry in `provideAppPrompts()` — no change to `AppComponent` or to
 * `AppPromptsService`.
 */
export const APP_PROMPTS = new InjectionToken<readonly AppPrompt[]>(
  'APP_PROMPTS'
);

/**
 * Declaration of every app-wide prompt: its queue id and its opening order
 * (lower opens first). Declared here, once, so a route's `skipAppPrompts`
 * data, the queue and the prompt service cannot drift apart by a typo.
 */
export const APP_PROMPT = {
  confirmationModal: { id: 'confirmation-modal', priority: 5 },
  onboarding: { id: 'onboarding', priority: 10 },
  npsSurvey: { id: 'nps-survey', priority: 20 }
} as const;

export type AppPromptId = (typeof APP_PROMPT)[keyof typeof APP_PROMPT]['id'];
